import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ index, eyebrow, title, sub, className = "", align = "left", testid }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}>
    <p className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.28em] text-ws-lime ${align === "center" ? "justify-center" : ""}`}>
      <span className="text-ws-muted">[{index}]</span>
      <span className="h-px w-8 bg-ws-lime/60" />
      {eyebrow}
    </p>
    <h2 data-testid={testid} className="mt-6 font-display text-3xl font-semibold leading-[1.12] tracking-tight text-ws-text sm:text-4xl lg:text-5xl">
      {title}
    </h2>
    {sub && <p className="mt-6 text-base leading-relaxed text-ws-muted md:text-lg">{sub}</p>}
  </Reveal>
);

export const spotlightMove = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};
